import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';
import { BuilderRequest } from 'src/app/models/requests';
import { DocumentModel, Thumbnail } from 'src/app/models/document.model';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ActorApiClient } from 'src/app/services/api-clients/actor.api-client';
import { PagesApiClient } from 'src/app/services/api-clients/pages.api-client';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom, Subscription } from 'rxjs';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RequestApiClient } from 'src/app/services/request.apiclient';
import { LoggingService } from 'src/app/services/logging.service';
import { Workflow } from 'src/app/models/workflow';
import { WorkflowService } from 'src/app/services/workflow.service';
import { RequestBuilderService } from './request-builder.service';
import { OrganisationSettingsApiClient } from 'src/app/services/organisation-settings.apiclient';
import { PlatformHubService } from 'src/app/services/platformhub.service';
import { Is_ANY_Download_Action } from 'src/app/constants/actor-action.enum';
import { SendGroupModel } from 'src/app/models/sendgroup.model';

@Component({
  templateUrl: './request-builder.page.html'
})
export class RequestBuilderPage implements OnDestroy {
  @Input('SignatureField') signatureField: any;
  @Input('SendRequest') sendrequest!: string;
  @Output('currentStep') step = new EventEmitter<string>();
  translations: any = <any>{};
  request: BuilderRequest = {} as BuilderRequest;
  requestId: string | null = this.route.snapshot.paramMap.get('requestId') ? this.route.snapshot.paramMap.get('requestId') : null;
  documents: DocumentModel[] = [];
  sendGroups: SendGroupModel[] = [];
  updateTimer: number = Date.now();
  activeStep: number = 0;
  delayCall = 500;
  pageId: number = 1;
  defaultPreloadPages: number = 5;
  isLoading: boolean = false;
  modalRef!: any;
  disabled = true;
  user!: User;
  progress: number[] = [0, 0, 0];
  // activeTab!: string;
  settings: any[] = [];
  showMessage: boolean = false;
  workflowData?: Workflow;
  currentTab: string = "AddDocuments";
  currentUserAdded: boolean = false;
  countDocuments: number = 0;
  countPersons: number = 0;
  notSupported: boolean = false;
  usersubscription: Subscription;
  currentTabSubscription: Subscription | null = null;
  workflowDataSubscription: Subscription | null = null;
  progressSubscription: Subscription | null = null;
  requestSubscription: Subscription | null = null;
  requestGuidSubscription: Subscription | null = null;

  /**
   * Needed to allow validate it in HTML
   */
  Is_ANY_Download_Action = Is_ANY_Download_Action;

  constructor(private requestBuilderService: RequestBuilderService,
     private documentService: DocumentApiClient, private actorService: ActorApiClient,
    private translateService: TranslateService, private pageService: PagesApiClient, private modalService: NgbModal,
    private sanitizer: DomSanitizer, private router: Router, private authenticationService: AuthenticationService,
    private requestService: RequestApiClient, private organisationSettingsApiClient: OrganisationSettingsApiClient,
    private loggingService: LoggingService, private workflowService: WorkflowService, private route: ActivatedRoute,
    private platformHub: PlatformHubService) {

    // also reset tab/workflow step back to Documents:
    this.requestBuilderService.setCurrentTab("AddDocuments");
    
    this.route.queryParams.subscribe((params: Params) => {

      this.requestBuilderService.setWorkflowId(params['workflowId']);
      if (!this.requestId) {
        this.requestBuilderService.setWorkflow();
      } else {
        this.requestBuilderService.setRequestGuid(this.requestId);
        this.requestBuilderService.getRequestById(this.requestId);
      }
    });
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.usersubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
    this.currentTabSubscription = this.requestBuilderService.currentTab$.subscribe(currentTab => {
      this.currentTab = currentTab;
    })
    this.requestSubscription = this.requestBuilderService.request$.subscribe(request => {
      this.request = request;
    })
    this.requestGuidSubscription = this.requestBuilderService.requestGuid$.subscribe(requestId => {
      this.requestId = requestId;
    })
    this.workflowDataSubscription = this.requestBuilderService.workflowData$.subscribe(workflowData => {
      this.workflowData = workflowData;
    })
    this.progressSubscription = this.requestBuilderService.progress$.subscribe(progress => {
      this.progress = progress;
    })

    this.organisationSettingsApiClient.getOrganisationSettings(this.user.organisationGuid).subscribe((data) => {
      this.settings = data;
      this.showMessage = false;
      if (this.settings.findIndex(os => os.key == "SigningNote") > -1) this.showMessage = JSON.parse(this.settings[this.settings.findIndex(os => os.key == "SigningNote")].value);
    });


  }

  /**
   * Verifies and returns the Secondary Crumb if possible. 
   * Is NULL when no suitable Crumb 
   */
  get getCrumbName(): string | null {
    if (this.request?.jobName !== undefined && this.request?.jobName !== null && this.request?.jobName !== "") {
      return this.request.jobName;
    }
    if (this.workflowData && this.workflowData.translationKey) {
      return this.translateService.instant(this.workflowData.translationKey);
    }
    return null;
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.ToastsRequestDocumentDeleted',
      'Toasts.UpdateDossierError',
      'Toasts.GetDocumentError',
      'Toasts.RequestSentError',
      'Toasts.RequestsPurgeError',
      'Toasts.DocumentTypeNotSupportedInWorkflow',
      'Toasts.Error',
      'Toasts.Sent',
      'Toasts.RequestSent',
      'Toasts.Deleted',
      'Toasts.Saved',
      'Toasts.KvKHeader',
      'Toasts.KvKBody',
      'Toasts.ContainsPreviousSignatures',
      'Toasts.RequestDocumentDeleteError'
    ]).subscribe(translation => {
      this.translations.toastsRequestDocumentDeleted = translation['Toasts.ToastsRequestDocumentDeleted'];
      this.translations.toastsUpdateDossierError = translation['Toasts.UpdateDossierError'];
      this.translations.toastsGetDocumentError = translation['Toasts.GetDocumentError'];
      this.translations.toastsRequestSentError = translation['Toasts.RequestSentError'];
      this.translations.toastsRequestsPurgeError = translation['Toasts.RequestsPurgeError'];
      this.translations.toastsDocumentTypeNotSupportedInWorkflow = translation['Toasts.DocumentTypeNotSupportedInWorkflow'];
      this.translations.error = translation['Toasts.Error'];
      this.translations.toastsSent = translation['Toasts.Sent'];
      this.translations.toastsRequestSent = translation['Toasts.RequestSent'];
      this.translations.toastsDeleted = translation['Toasts.Deleted'];
      this.translations.toastsSaved = translation['Toasts.Saved'];
      this.translations.KvKHeader = translation['Toasts.KvKHeader'];
      this.translations.KvKBody = translation['Toasts.KvKBody'];
      this.translations.toastsContainsPreviousSignatures = translation['Toasts.ContainsPreviousSignatures'];
      this.translations.toastsRequestDocumentDeleteError = translation['Toasts.RequestDocumentDeleteError']
    });
  }

  async ngOnDestroy() {
    this.requestBuilderService.setRequestGuid("");

    if (this.usersubscription) {
      this.usersubscription.unsubscribe();
    }
    if (this.currentTabSubscription) {
      this.currentTabSubscription.unsubscribe();
    }
    if (this.workflowDataSubscription) {
      this.workflowDataSubscription.unsubscribe();
    }
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
    if (this.requestGuidSubscription) {
      this.requestGuidSubscription.unsubscribe();
    }
  }


  async recursiveUpdateActionPerson(index: number) {
    let actorToUpdate = this.request.actors[index];
    if (!actorToUpdate.documentId || !actorToUpdate.id) {
      if (index < this.request.actors.length - 1)
        this.recursiveUpdateActionPerson(index + 1).catch((error) => this.loggingService.logException(error));
    } else {
      try {
        let updateActionToPerson = await this.actorService.updateActionToPerson(this.request.id!, actorToUpdate.documentId, actorToUpdate);
        let value: any = await lastValueFrom(updateActionToPerson);
        let actor = this.request.actors.find(item => item.id == value.id);
        if (actor) {
          actor = value;
        }
        if (index < this.request.actors.length - 1)
          this.recursiveUpdateActionPerson(index + 1).catch((error) => this.loggingService.logException(error));
      } catch (error: any) {
        this.loggingService.logException(error);
      }
    }
  }

  public async getThumbnailAddDocument(event: any) {
    await this.getThumbnail(event.document.document, event.pageId, event.ifNotExists);
  }
  private async getThumbnail(doc: DocumentModel, pageId: number, ifNotExists: boolean) {
    if (pageId <= 0 || pageId > doc.pages) return;
    if (doc.thumbnails == null) doc.thumbnails = [];
    if (pageId > doc.pages) return;
    let index = doc.thumbnails.findIndex(t => t.PageId == pageId);
    if (ifNotExists && index > -1) return;
    try {
      let getRequest = await this.pageService.getThumbnail(this.request.id, doc.id, pageId);
      let data = await lastValueFrom(getRequest);
      let index = doc.thumbnails.findIndex(t => t.PageId == pageId);
      let thumbnail = new Thumbnail();
      thumbnail.PageId = pageId;
      thumbnail.ThumbnailUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(data));
      if (index > -1) doc.thumbnails[index] = thumbnail;
      else doc.thumbnails.push(thumbnail);
    } catch (error: any) {
      this.loggingService.logException(error);
    }
  }
  public currentUserAddedChange(event: boolean) {
    this.currentUserAdded = event;
  }

  public organisationHasKVK() {
    return this.requestBuilderService.organisationHasKVK;
  }
}

